// import anime from 'animejs'; // Import anime.js for animations

// export class SearchBar {
//     private selector: string;
//     private searchIcon: HTMLElement;
//     private inputField: HTMLInputElement;
//     private defaultPlaceholder: string;
//     private isActive: boolean;
//     private filterSelector: string;
//     private useCustomSearchLogic: boolean;
//     private customSearchLogic: Function;

//     constructor(selector: string = ".searchBar", options: { filterSelector: string, useCustomSearchLogic?: boolean, customSearchLogic?: Function }) {
//         this.selector = selector;

//         if (!options || !options.filterSelector) {
//             throw new Error('Missing required "filterSelector" option');
//         }

//         this.filterSelector = options.filterSelector;
//         this.useCustomSearchLogic = options.useCustomSearchLogic || false;
//         this.customSearchLogic = options.customSearchLogic || null;

//         try {
//             this.waitForSelector(this.selector)
//                 .then(() => {
//                     this.waitForSelector(this.filterSelector)
//                         .then(() => {
//                             this.searchIcon = document.querySelector(`${this.selector} .icon`) as HTMLElement;
//                             this.inputField = document.querySelector(`${this.selector} input`) as HTMLInputElement;
//                             this.defaultPlaceholder = 'Search';
//                             this.isActive = false;

//                             this.init();
//                             console.log('SearchBar initialized successfully');
//                         }).catch(error => {
//                             throw error;
//                         });
//                 }).catch(error => {
//                     throw error;
//                 });
//         } catch (error) {
//             console.error('Error while initializing SearchBar: ', error);
//         }
//     }

//     private waitForSelector(selector: string): Promise<void> {
//         return new Promise((resolve, reject) => {
//             const interval = setInterval(() => {
//                 const element = document.querySelector(selector);
//                 if (element) {
//                     clearInterval(interval);
//                     resolve();
//                 }
//             }, 100);

//             setTimeout(() => {
//                 clearInterval(interval);
//                 reject(new Error(`Selector "${selector}" not found`));
//             }, 30000);
//         });
//     }

//     private loadAnimeJS(): void {
//         if (typeof anime === 'undefined') {
//             const script = document.createElement('script');
//             script.src = 'https://cdn.jsdelivr.net/npm/animejs@3.2.1/lib/anime.min.js';
//             script.onload = () => console.log("anime.js is now loaded");
//             document.head.appendChild(script);
//         }
//     }

//     private slideIconOut(): void {
//         anime({
//             targets: this.searchIcon,
//             translateX: -10,
//             opacity: 0,
//             easing: 'easeInOutQuad',
//             duration: 300,
//         });
//     }

//     private slideIconIn(): void {
//         anime({
//             targets: this.searchIcon,
//             translateX: 0,
//             opacity: 1,
//             easing: 'easeInOutQuad',
//             duration: 300,
//         });
//     }

//     private handleFocus(): void {
//         if (this.inputField.value === '' && this.inputField.placeholder === this.defaultPlaceholder) {
//             this.inputField.placeholder = '';
//         }
//         this.slideIconOut();
//         this.isActive = true;
//     }

//     private handleBlur(): void {
//         if (this.inputField.value === '') {
//             this.inputField.placeholder = this.defaultPlaceholder;
//             this.slideIconIn();
//         }
//         this.isActive = false;
//     }

//     private handleIconClick(): void {
//         if (!this.isActive) {
//             this.inputField.focus();
//         } else {
//             this.inputField.blur();
//         }
//     }

//     private addEventListeners(): void {
//         this.inputField.addEventListener('focus', this.handleFocus.bind(this));
//         this.inputField.addEventListener('blur', this.handleBlur.bind(this));
//         this.searchIcon.addEventListener('click', this.handleIconClick.bind(this));
//         this.inputField.addEventListener('keyup', this.useCustomSearchLogic
//             ? this.customSearchLogic.bind(this)
//             : this.searchPage.bind(this));
//     }

//     private init(): void {
//         this.loadAnimeJS();
//         this.addEventListeners();
//     }

//     private searchPage(): void {
//         const query = this.inputField.value.trim();
//         const chartDataElements = document.querySelectorAll(this.filterSelector);
//         const chartData = Array.from(chartDataElements).map(element => element.textContent.trim());

//         const filteredData = chartData.filter(data => data.toLowerCase().includes(query.toLowerCase()));

//         chartDataElements.forEach(element => {
//             const data = element.textContent.trim();
//             (element as HTMLElement).style.display = filteredData.includes(data) ? 'table-row' : 'none';
//         });
//     }
// }
import anime from 'animejs';

export class SearchBar {
    private selector: string;
    private searchIcon: HTMLElement;
    private inputField: HTMLInputElement;
    private defaultPlaceholder: string;
    private isActive: boolean;
    private filterSelector: string;
    private useCustomSearchLogic: boolean;
    private customSearchLogic: Function;
    private customSpinnerStart: Function;
    private customSpinnerEnd: Function;
    private debounceTime: number;

    constructor(selector: string = ".searchBar", options: { filterSelector: string, useCustomSearchLogic?: boolean, customSearchLogic?: Function, debounceTime?: number, customSpinnerStart?: Function, customSpinnerEnd?: Function }) {
        this.selector = selector;

        if (!options || !options.filterSelector) {
            throw new Error('Missing required "filterSelector" option');
        }

        this.filterSelector = options.filterSelector;
        this.useCustomSearchLogic = options.useCustomSearchLogic || false;
        this.customSearchLogic = options.customSearchLogic || null;
        this.debounceTime = options.debounceTime || 300; // Default debounce time: 300ms
        this.customSpinnerStart = options.customSpinnerStart || null;
        this.customSpinnerEnd = options.customSpinnerEnd || null;

        try {
            this.waitForSelector(this.selector)
                .then(() => {
                    this.waitForSelector(this.filterSelector)
                        .then(() => {
                            this.searchIcon = document.querySelector(`${this.selector} .icon`) as HTMLElement;
                            this.inputField = document.querySelector(`${this.selector} input`) as HTMLInputElement;
                            this.defaultPlaceholder = 'Search';
                            this.isActive = false;

                            this.init();
                            console.log('SearchBar initialized successfully');
                        }).catch(error => {
                            throw error;
                        });
                }).catch(error => {
                    throw error;
                });
        } catch (error) {
            console.error('Error while initializing SearchBar: ', error);
        }
    }

    private waitForSelector(selector: string): Promise<void> {
        return new Promise((resolve, reject) => {
            const interval = setInterval(() => {
                const element = document.querySelector(selector);
                if (element) {
                    clearInterval(interval);
                    resolve();
                }
            }, 100);

            setTimeout(() => {
                clearInterval(interval);
                reject(new Error(`Selector "${selector}" not found`));
            }, 30000);
        });
    }

    private loadAnimeJS(): void {
        if (typeof anime === 'undefined') {
            const script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/npm/animejs@3.2.1/lib/anime.min.js';
            script.onload = () => console.log("anime.js is now loaded");
            document.head.appendChild(script);
        }
    }

    private slideIconOut(): void {
        anime({
            targets: this.searchIcon,
            translateX: -10,
            opacity: 0,
            easing: 'easeInOutQuad',
            duration: 300,
        });
    }

    private slideIconIn(): void {
        anime({
            targets: this.searchIcon,
            translateX: 0,
            opacity: 1,
            easing: 'easeInOutQuad',
            duration: 300,
        });
    }

    private handleFocus(): void {
        if (this.inputField.value === '' && this.inputField.placeholder === this.defaultPlaceholder) {
            this.inputField.placeholder = '';
        }
        this.slideIconOut();
        this.isActive = true;
    }

    private handleBlur(): void {
        if (this.inputField.value === '') {
            this.inputField.placeholder = this.defaultPlaceholder;
            this.slideIconIn();
        }
        this.isActive = false;
    }

    private handleIconClick(): void {
        if (!this.isActive) {
            this.inputField.focus();
        } else {
            this.inputField.blur();
        }
    }

    private addEventListeners(): void {
        this.inputField.addEventListener('focus', this.handleFocus.bind(this));
        this.inputField.addEventListener('blur', this.handleBlur.bind(this));
        this.searchIcon.addEventListener('click', this.handleIconClick.bind(this));
        this.inputField.addEventListener(
            'input',
            this.debounce(
                this.debounceTime,
                this.customSpinnerStart !== null ? this.customSpinnerStart : () => { },
                this.useCustomSearchLogic ? this.customSearchLogic : this.searchPage.bind(this),
                this.customSpinnerEnd !== null ? this.customSpinnerEnd : () => { },
            ) as EventListener
        );
    }

    private init(): void {
        this.loadAnimeJS();
        this.addEventListeners();
    }

    private searchPage(): void {
        const query = this.inputField.value.trim().toLowerCase();
        const chartDataElements = document.querySelectorAll(this.filterSelector);

        chartDataElements.forEach(element => {
            const data = element.textContent.trim().toLowerCase();
            (element as HTMLElement).style.display = data.includes(query) ? 'table-row' : 'none';
        });
    }

    private debounce(delay: number, ...fns: Function[]): Function {
        let timeout: NodeJS.Timeout;

        return (...args: any[]) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                fns.forEach(fn => fn(...args));
            }, delay);
        };
    }
}